import React, { useState } from 'react';
import { folderService } from '../../../services/api';

interface CreateFolderModalProps {
  onClose: () => void;
  onSuccess: () => void;
  parentFolderId?: number | null;
}

const CreateFolderModal: React.FC<CreateFolderModalProps> = ({ onClose, onSuccess, parentFolderId }) => {
  const [folderName, setFolderName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!folderName.trim()) {
      setError('El nombre de la carpeta es requerido');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await folderService.createFolder({ 
        name: folderName.trim(),
        parent_folder_id: parentFolderId 
      });
      if (response.success) {
        onSuccess();
      } else {
        setError(response.error || 'Error al crear la carpeta');
      }
    } catch (error) {
      console.error('Error creating folder:', error);
      setError('Error al crear la carpeta');
    } finally {
      setLoading(false);
    }
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2>{parentFolderId ? 'Crear Subcarpeta' : 'Crear Nueva Carpeta'}</h2>
          <button onClick={onClose} className="close-btn">
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="folderName">Nombre de la carpeta</label>
            <input
              type="text"
              id="folderName"
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              placeholder="Ingresa el nombre de la carpeta"
              disabled={loading}
              autoFocus
            />
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Creando...' : 'Crear Carpeta'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateFolderModal;